export default "__VITE_ASSET__BqZpFv$n__"